import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

import { environment } from '../../environments/environment';

export interface Bank {
  id: number;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class BankService {
  private readonly url = `${environment.apiUrl}/banks`;
  private cache$: Observable<{ banks: Bank[] }> | null = null;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<{ banks: Bank[] }> {
    if (!this.cache$) {
      this.cache$ = this.http.get<{ banks: Bank[] }>(this.url).pipe(shareReplay(1));
    }
    return this.cache$;
  }
}
